import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import {
  Container,
  Grid,
  Card,
  CardContent,
  Typography,
  Box,
  CircularProgress,
  Divider,
  CardMedia,
  Button,
} from '@mui/material';
import Header2 from '../components/Header2/Header2';
import Scrollbar from '../components/scrollbar/scrollbar';
import CtaSection from '../components/CtaSection/CtaSection';
import Footer from '../components/footer/Footer';
import { useDispatch, useSelector } from 'react-redux';
import BusinessIcon from '@mui/icons-material/Business';

import { fetchOrderBilling } from '../features/billing/billingSlice';
import Swal from 'sweetalert2';
import { useNavigate } from 'react-router-dom';
import PhoneInput, { isValidPhoneNumber } from 'react-phone-number-input';
import 'react-phone-number-input/style.css';
import {
  Delete,
  AttachMoney,
  LocationOn,
  CalendarToday,
  Event,
  ShoppingCart,
  AccountBalance,
  LocalShipping,
  Timer,
  PriceChange,
  Scale,
  LocalAtm,
  AddCircle,
  AccessTime,
  MonetizationOn,
  WarningAmber,
  ReceiptLong,
} from '@mui/icons-material';
import Loader from './Loader/loader';
import { placeOrder } from '../features/orders/orderSlice';
import { uploadMedia } from '../features/media/mediaSlice';
import DumpsterImage from '../images/dumpster.png';

const OrderPage = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { order } = useSelector((state) => state.orders);
  const [orderLoading, setOrderLoading] = useState(false);

  const { billingData, loading } = useSelector((state) => state.billing);
  const { singleCompanyDumpster } = useSelector((state) => state.dumpsters);
  console.log('singleCompanyDumpster', singleCompanyDumpster);

  const slug = singleCompanyDumpster?.data?.company?.slug;
  console.log('====================================');
  console.log('order', order);
  console.log('====================================');
  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    email: '',
    phone: '',
    image: null,
  });
  // useEffect(() => {
  //   if (order && singleCompanyDumpster && !billingData) {
  //     // Prevent re-fetching if billingData exists
  //     const data = {
  //       dumpster_id: order.dumpster_id,
  //       from_date: order.from_date,
  //       to_date: order.to_date,
  //       delivery_address: {
  //         address: order.delivery_address?.address,
  //         coords: {
  //           latitude: order.delivery_address?.coords?.latitude,
  //           longitude: order.delivery_address?.coords?.longitude,
  //         },
  //       },
  //       note: order.note || 'No additional notes',
  //     };
  //     dispatch(fetchOrderBilling({ slug, data }));
  //   }
  // }, [order, slug, singleCompanyDumpster, dispatch, billingData]);
  useEffect(() => {
    if (order && singleCompanyDumpster) {
      (async () => {
        const data = {
          dumpster_size_id: order.dumpster_size_id,
          waste_type_id: order.waste_type_id,
          is_wallet_used: order.is_wallet_used,
          location_type: order.location_type,
          business_name: order?.business_name,
          promotion_id: order?.promotion_id,
          from_date: order.from_date,
          to_date: order.to_date,
          delivery_address: {
            address: order.delivery_address?.address,
            coords: {
              latitude: order.delivery_address?.coords?.latitude,
              longitude: order.delivery_address?.coords?.longitude,
            },
          },
          note: order.note || 'No additional notes',
        };

        try {
          await dispatch(fetchOrderBilling({ slug, data })).unwrap();
        } catch (error) {
          Swal.fire({
            icon: 'error',
            title: 'Failed to Fetch Billing',
            text:
              error || 'An error occurred while fetching billing information.',
            timer: 5000, // Auto close after 5 seconds
            timerProgressBar: true,
            showConfirmButton: false,
            willClose: () => {
              // Redirect after the alert is closed
              navigate(`/dumpster/${slug}/${order?.dumpster_size_id}`);
            },
          });
        }
      })();
    }
  }, [order, slug, singleCompanyDumpster, dispatch, navigate]);
  // useEffect(() => {
  //   if (order && singleCompanyDumpster) {
  //     (async () => {
  //       const data = {
  //         dumpster_id: order.dumpster_id,
  //         from_date: order.from_date,
  //         to_date: order.to_date,
  //         delivery_address: {
  //           address: order.delivery_address?.address,
  //           coords: {
  //             latitude: order.delivery_address?.coords?.latitude,
  //             longitude: order.delivery_address?.coords?.longitude,
  //           },
  //         },
  //         note: order.note || 'No additional notes',
  //       };
  //       console.log('====================================');
  //       console.log('singleCompanyDumpster', singleCompanyDumpster);
  //       console.log(
  //         'singleCompanyDumpster',
  //         singleCompanyDumpster.data.company_id
  //       );
  //       console.log(
  //         'singleCompanyDumpster',
  //         singleCompanyDumpster.data.company.name
  //       );
  //       console.log('====================================');
  //            to={`/dumpster/${slug}/${dumpster.id}`}
  //       try {
  //         await dispatch(fetchOrderBilling({ slug, data })).unwrap();
  //       } catch (error) {
  //         Swal.fire({
  //           icon: 'error',
  //           title: 'Failed to Fetch Billing',
  //           text:
  //             error || 'An error occurred while fetching billing information.',
  //         });
  //       }
  //     })();
  //   }
  // }, [order, slug, singleCompanyDumpster, dispatch]);
  const handlePlaceOrder = async () => {
    let missingFields = [];

    // 🔎 Check required fields
    if (!formData.firstName?.trim()) missingFields.push('First Name');
    if (!formData.email?.trim()) missingFields.push('Email');
    if (!formData.phone?.trim()) missingFields.push('Phone number');
    if (!order || !order.dumpster_size_id) missingFields.push('Dumpster ID');

    // 🚨 Show all missing fields in one alert
    if (missingFields.length > 0) {
      Swal.fire({
        icon: 'error',
        title: 'Missing Required Fields',
        html: `<ul style="text-align:left;">
        ${missingFields
          .map((field) => `<li>${field} is required</li>`)
          .join('')}
      </ul>`,
      });
      return;
    }

    // 📧 Validate email separately (only if it's not empty)
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(formData.email)) {
      Swal.fire({
        icon: 'error',
        title: 'Invalid Email',
        text: 'Please enter a valid email address (e.g., name@example.com).',
      });
      return;
    }

    setOrderLoading(true); // 🔥 Start loading
    let mediaUrl = null;

    if (formData.image) {
      const formDataForUpload = new FormData();
      formDataForUpload.append('media[]', formData.image); // 👈 wrap single image in array

      try {
        const result = await dispatch(uploadMedia(formDataForUpload)).unwrap();
        mediaUrl = result?.url; // 👈 assuming backend still returns { url }
      } catch (error) {
        Swal.fire({
          icon: 'error',
          title: 'Image Upload Failed',
          text: error || 'Failed to upload image. Please try again.',
        });
        setOrderLoading(false); // 🧯 Stop loading on error
        return;
      }
    }

    const fullData = new FormData();
    fullData.append('first_name', formData.firstName);
    fullData.append('last_name', formData.lastName);
    fullData.append('email', formData.email);
    fullData.append('phone', formData.phone);

    if (mediaUrl) {
      fullData.append('media[0]', mediaUrl); // 👈 store as array
    }

    if (order) {
      Object.keys(order).forEach((key) => {
        if (typeof order[key] === 'object' && order[key] !== null) {
          if (key === 'delivery_address') {
            Object.keys(order[key]).forEach((nestedKey) => {
              if (nestedKey === 'coords') {
                fullData.append(
                  `delivery_address[coords][latitude]`,
                  order[key][nestedKey].latitude
                );
                fullData.append(
                  `delivery_address[coords][longitude]`,
                  order[key][nestedKey].longitude
                );
              } else {
                fullData.append(
                  `delivery_address[${nestedKey}]`,
                  order[key][nestedKey]
                );
              }
            });
          }
        } else {
          fullData.append(key, order[key]);
        }
      });
    }

    try {
      const result = await dispatch(
        placeOrder({ formData: fullData, slug })
      ).unwrap();
      dispatch({ type: 'RESET_ALL' });

      Swal.fire({
        icon: 'success',
        title: 'Order Placed!',
        text: result?.message || 'Your order has been successfully placed.',
        timer: 10000,
        showConfirmButton: false,
      }).then(() => {
        navigate(`/company/${slug}`);
      });
    } catch (error) {
      Swal.fire({
        icon: 'error',
        title: 'Order Failed',
        text: error || 'Failed to place order. Please try again.',
      });
    } finally {
      setOrderLoading(false); // ✅ Always stop loading after everything
    }
  };

  // const handlePlaceOrder = async () => {
  //   if (!order || !order.dumpster_size_id) {
  //     Swal.fire({
  //       icon: 'error',
  //       title: 'Oops...',
  //       text: 'Dumpster ID is required!',
  //     });
  //     return;
  //   }
  //   setOrderLoading(true); // 🔥 Start loading
  //   let mediaUrl = null;
  //   if (formData.image) {
  //     const formDataForUpload = new FormData();
  //     formDataForUpload.append('media', formData.image);

  //     try {
  //       const result = await dispatch(uploadMedia(formDataForUpload)).unwrap();
  //       mediaUrl = result?.url;
  //     } catch (error) {
  //       Swal.fire({
  //         icon: 'error',
  //         title: 'Image Upload Failed',
  //         text: error || 'Failed to upload image. Please try again.',
  //       });
  //       setOrderLoading(false); // 🧯 Stop loading on error
  //       return;
  //     }
  //   }

  //   const fullData = new FormData();
  //   fullData.append('first_name', formData.firstName);
  //   fullData.append('last_name', formData.lastName);
  //   fullData.append('email', formData.email);
  //   fullData.append('phone', formData.phone);

  //   if (mediaUrl) {
  //     fullData.append('image_url', mediaUrl);
  //   }

  //   if (order) {
  //     Object.keys(order).forEach((key) => {
  //       if (typeof order[key] === 'object' && order[key] !== null) {
  //         if (key === 'delivery_address') {
  //           Object.keys(order[key]).forEach((nestedKey) => {
  //             if (nestedKey === 'coords') {
  //               fullData.append(
  //                 `delivery_address[coords][latitude]`,
  //                 order[key][nestedKey].latitude
  //               );
  //               fullData.append(
  //                 `delivery_address[coords][longitude]`,
  //                 order[key][nestedKey].longitude
  //               );
  //             } else {
  //               fullData.append(
  //                 `delivery_address[${nestedKey}]`,
  //                 order[key][nestedKey]
  //               );
  //             }
  //           });
  //         }
  //       } else {
  //         fullData.append(key, order[key]);
  //       }
  //     });
  //   }
  //   try {
  //     const result = await dispatch(
  //       placeOrder({ formData: fullData, slug })
  //     ).unwrap();
  //     dispatch({ type: 'RESET_ALL' });
  //     Swal.fire({
  //       icon: 'success',
  //       title: 'Order Placed!',
  //       text: result?.message || 'Your order has been successfully placed.',
  //       timer: 4000,
  //       showConfirmButton: false,
  //     }).then(() => {
  //       navigate(`/company/${slug}`);
  //     });
  //   } catch (error) {
  //     Swal.fire({
  //       icon: 'error',
  //       title: 'Order Failed',
  //       text: error || 'Failed to place order. Please try again.',
  //     });
  //   } finally {
  //     setOrderLoading(false); // ✅ Always stop loading after everything
  //   }
  // };

  if (loading || !order || !singleCompanyDumpster || !billingData) {
    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        height="100vh"
      >
        <Loader />
      </Box>
    );
  }

  const { billing } = billingData?.data || {};

  return (
    <>
      {/* className="page_content overflow-hidden" */}
      <main>
        <Header2 OrderBilling=" Order Billing" />
        <Box sx={{ mt: 1, p: 3 }}>
          <motion.div
            initial={{ opacity: 0, y: -20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5 }}
          >
            {/* <Typography
              sx={{
                color: '#14331D',
                fontFamily: 'var(--font-body)', // Ensures Plus Jakarta Sans is applied
                fontWeight: '500',
              }}
              variant="h5"
              textAlign="center"
            >
              Order Billing
            </Typography> */}
          </motion.div>
          <Container maxWidth="md">
            <Grid container spacing={4} mt={1}>
              <Grid item xs={12}>
                <motion.div
                  initial={{ opacity: 0, scale: 0.9 }}
                  animate={{ opacity: 1, scale: 1 }}
                  transition={{ duration: 0.5, ease: 'easeOut' }}
                >
                  <Card
                    sx={{
                      borderRadius: 3,
                    }}
                  >
                    <Box sx={{ display: 'flex', alignItems: 'center', p: 1.5 }}>
                      <motion.div
                        whileHover={{ scale: 1.1 }}
                        transition={{ duration: 0.3, ease: 'easeOut' }}
                      >
                        <CardMedia
                          component="img"
                          sx={{
                            width: 80,
                            height: 80,
                            borderRadius: '50%',
                            objectFit: 'cover',
                            boxShadow: 3,
                            mr: 2,
                          }}
                          image={billing?.dumpster_size?.image || DumpsterImage}
                          alt="Dumpster Image"
                        />
                      </motion.div>
                      <CardContent sx={{ textAlign: 'left', p: 0 }}>
                        <Typography
                          variant="p"
                          sx={{ fontFamily: 'var(--font-body)' }}
                          mb={0.5}
                        >
                          {billing?.dumpster_size?.name}
                        </Typography>
                        <Typography
                          variant="body1"
                          sx={{
                            fontFamily: 'var(--font-body)',
                            fontWeight: 500, // Ensuring font weight is applied
                          }}
                          mb={0.5}
                        >
                          ID: {billing?.dumpster_size?.id}
                        </Typography>
                      </CardContent>
                    </Box>
                    <Divider
                      sx={{
                        borderBottom: '2px solid gray',
                        width: '95%',
                        mx: 'auto',
                      }}
                    />
                    <Card
                      sx={{
                        // background: '#F2F7EC',
                        m: { xs: 2, sm: 2, md: 3, lg: 4 },
                        borderRadius: '12px',
                        px: 3,
                        pt: 2,
                        pb: 3,
                      }}
                    >
                      <Box sx={{ textAlign: 'center', mb: 3 }}>
                        <Typography
                          fontWeight="600"
                          variant="h5"
                          sx={{
                            fontFamily: 'var(--font-body)',
                            color: '#75AD3E',
                          }}
                        >
                          Dumpster Size Detail
                        </Typography>
                      </Box>

                      <CardContent sx={{ px: { xs: 0, sm: 0, md: 5, lg: 5 } }}>
                        <Grid container spacing={2} columnSpacing={12}>
                          {[
                            {
                              icon: <ShoppingCart sx={{ color: '#14331D' }} />,
                              label: 'Name',
                              value: billing?.dumpster_size?.name,
                            },
                            {
                              icon: <LocalShipping sx={{ color: '#14331D' }} />,
                              label: 'Size',
                              value: billing?.dumpster_size?.name,
                            },
                            {
                              icon: <Scale sx={{ color: '#14331D' }} />,
                              label: 'Weight Capacity',
                              value: `${billing?.dumpster_size?.weight} Ton`,
                            },
                            {
                              icon: <AccessTime sx={{ color: '#14331D' }} />,
                              label: 'Extra Day Charge',
                              value: `$${billing?.dumpster_size?.extra_day_charge} per day`,
                            },
                            {
                              icon: <AttachMoney sx={{ color: '#14331D' }} />,
                              label: 'Fare',
                              value: billing?.promotion_discount
                                ? `$${(
                                    billing?.subtotal -
                                    billing?.promotion_discount
                                  ).toFixed(2)} / ${
                                    billing?.dumpster_size?.minimum_days
                                  } days`
                                : `$${(billing?.subtotal || 0).toFixed(2)} / ${
                                    billing?.dumpster_size?.minimum_days
                                  } days`,
                            },
                            {
                              icon: <WarningAmber sx={{ color: '#14331D' }} />,
                              label: 'Overload Charge',
                              value: `$${billing?.dumpster_size?.overload_charge}`,
                            },
                          ].map((item, index, arr) => (
                            <Grid item xs={12} sm={6} key={index}>
                              <Box
                                sx={{
                                  display: 'flex',
                                  alignItems: 'center',
                                  justifyContent: 'space-between',
                                  borderBottom:
                                    index < arr.length - 2
                                      ? '1px solid #D3E2C2'
                                      : 'none',
                                  pb: 1,
                                }}
                              >
                                <Box
                                  sx={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: 1.5,
                                  }}
                                >
                                  <Box
                                    sx={{
                                      width: 36,
                                      height: 36,
                                      borderRadius: '50%',
                                      backgroundColor: '#f2f2f2',
                                      display: 'flex',
                                      alignItems: 'center',
                                      justifyContent: 'center',
                                      flexShrink: 0,
                                    }}
                                  >
                                    {item?.icon}
                                  </Box>
                                  <Typography
                                    sx={{
                                      fontWeight: '400',
                                      fontFamily: 'var(--font-body)',
                                      fontSize: '15px',
                                      color: '#14331D',
                                    }}
                                  >
                                    {item?.label}
                                  </Typography>
                                </Box>

                                <Typography
                                  sx={{
                                    fontWeight: '400',
                                    fontFamily: 'var(--font-body)',
                                    fontSize: '15px',
                                    color: '#14331D',
                                    textAlign: 'right',
                                  }}
                                >
                                  {item?.value}
                                </Typography>
                              </Box>
                            </Grid>
                          ))}
                        </Grid>
                      </CardContent>
                    </Card>

                    <Card
                      sx={{
                        ml: { xs: 2, sm: 2, md: 3, lg: 4 },
                        mr: { xs: 2, sm: 2, md: 3, lg: 4 },
                        mb: { xs: 2, sm: 2, md: 3, lg: 4 },
                        mt: 6,
                        borderRadius: '12px',
                        pl: 3,
                        pr: 3,
                        pt: 1,
                      }}
                    >
                      <Box sx={{ textAlign: 'center', mb: 3 }}>
                        <Typography
                          fontWeight="600"
                          variant="h5"
                          sx={{
                            fontFamily: 'var(--font-body)',
                            color: '#75AD3E',
                          }}
                        >
                          Ordering Detail
                        </Typography>
                      </Box>

                      <CardContent sx={{ px: { xs: 0, sm: 0, md: 5, lg: 5 } }}>
                        <Grid container spacing={2} columnSpacing={12}>
                          {/* General Details */}
                          {[
                            {
                              icon: <CalendarToday />,
                              label: 'From',
                              value: billing?.from_date,
                            },
                            {
                              icon: <Event />,
                              label: 'To',
                              value: billing?.to_date || 'N/A',
                            },
                            {
                              icon: <AccessTime />,
                              label: 'Extra Days',
                              value: `${billing?.extra_days} days`,
                            },

                            {
                              icon: <LocationOn />,
                              label: 'Location Type',
                              value: order?.location_type,
                            },
                            ...(order?.business_name
                              ? [
                                  {
                                    icon: <BusinessIcon />,
                                    label: 'Business Name',
                                    value: order.business_name,
                                  },
                                ]
                              : []),
                          ].map((item, index) => (
                            <Grid item xs={12} sm={6} key={index}>
                              <Box
                                sx={{
                                  display: 'flex',
                                  alignItems: 'center',
                                  justifyContent: 'space-between',
                                  borderBottom: '1px solid #D3E2C2',
                                  pb: 1,
                                }}
                              >
                                <Box
                                  sx={{ display: 'flex', alignItems: 'center' }}
                                >
                                  <Box
                                    sx={{
                                      background: '#fff',
                                      borderRadius: '50%',
                                      padding: '8px',
                                      display: 'flex',
                                      alignItems: 'center',
                                      justifyContent: 'center',
                                      boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
                                      mr: 1.5,
                                    }}
                                  >
                                    {item?.icon}
                                  </Box>
                                  <Typography
                                    sx={{
                                      fontSize: '15px',
                                      color: '#14331D',
                                      fontFamily: 'var(--font-body)',
                                    }}
                                  >
                                    {item?.label}
                                  </Typography>
                                </Box>
                                <Typography
                                  sx={{
                                    fontSize: '15px',
                                    color: '#14331D',
                                    fontFamily: 'var(--font-body)',
                                  }}
                                >
                                  {item?.value || 'N/A'}
                                </Typography>
                              </Box>
                            </Grid>
                          ))}
                          {/* Address Section */}
                          <Grid item xs={12}>
                            <Box
                              sx={{
                                display: 'flex',
                                alignItems: 'flex-start',
                                borderBottom: 'none',
                              }}
                            >
                              <Box
                                sx={{
                                  background: '#fff',
                                  borderRadius: '50%',
                                  padding: '8px',
                                  display: 'flex',
                                  alignItems: 'center',
                                  justifyContent: 'center',
                                  boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
                                  mr: 1.5,
                                }}
                              >
                                <LocationOn />
                              </Box>
                              <Box>
                                <Typography
                                  sx={{
                                    fontSize: '15px',
                                    color: '#14331D',
                                    fontFamily: 'var(--font-body)',
                                  }}
                                >
                                  Address
                                </Typography>
                                <Typography
                                  sx={{
                                    fontSize: '15px',
                                    color: '#14331D',
                                    fontWeight: 'bold',
                                    wordWrap: 'break-word',
                                    maxWidth: '100%',
                                    fontFamily: 'var(--font-body)',
                                  }}
                                >
                                  {billing?.delivery_address?.address}
                                </Typography>
                              </Box>
                            </Box>
                          </Grid>
                          {/* Divider Section for Pricing */}
                          <Grid item xs={12}>
                            <Divider sx={{ my: 2 }} />
                            <Box
                              sx={{
                                display: 'flex',
                                flexDirection: 'column',
                                gap: 1.5,
                                p: 2,
                                background: '#F9FAF7',
                                borderRadius: '8px',
                              }}
                            >
                              {[
                                {
                                  icon: <AttachMoney fontSize="small" />,
                                  label: 'Subtotal',
                                  value: `$${billing?.subtotal?.toFixed(2)}`,
                                },
                                {
                                  icon: <AddCircle fontSize="small" />,
                                  label: 'Extra Days Charges',
                                  value: `$${billing?.extra_day_charge?.toFixed(
                                    2
                                  )}`,
                                },
                                {
                                  icon: <PriceChange fontSize="small" />,
                                  label: 'Promotion Discount',
                                  value:
                                    billing?.promotion_discount &&
                                    billing?.promotion_discount > 0
                                      ? `- $${billing?.promotion_discount}`
                                      : 'N/A',
                                  color: 'error.main',
                                },
                                {
                                  icon: <LocalAtm fontSize="small" />,
                                  label: 'Tax',
                                  value: `$${billing?.dumpster_size?.tax?.toFixed(
                                    2
                                  )}`,
                                },
                              ].map((row, idx) => (
                                <Box
                                  key={idx}
                                  sx={{
                                    display: 'flex',
                                    justifyContent: 'space-between',
                                    alignItems: 'center',
                                  }}
                                >
                                  <Box
                                    sx={{
                                      display: 'flex',
                                      alignItems: 'center',
                                      gap: 0.5,
                                    }}
                                  >
                                    {row.icon}
                                    <Typography>{row.label}</Typography>
                                  </Box>
                                  <Typography
                                    sx={{ color: row.color || 'inherit' }}
                                  >
                                    {row.value}
                                  </Typography>
                                </Box>
                              ))}
                            </Box>
                            <Divider sx={{ my: 2 }} />
                          </Grid>
                        </Grid>
                      </CardContent>
                    </Card>

                    <Card
                      sx={{
                        // background: '#EDF4E5',
                        ml: { xs: 2, sm: 2, md: 3, lg: 4 },
                        mr: { xs: 2, sm: 2, md: 3, lg: 4 },
                        mb: { xs: 2, sm: 2, md: 3, lg: 4 },
                        mt: 6,
                        borderRadius: '12px',
                        pl: 3,
                        pr: 3,
                        pt: 1,
                      }}
                    >
                      <Box sx={{ textAlign: 'center', mb: 3 }}>
                        <Typography
                          fontWeight="600"
                          variant="h5"
                          sx={{
                            fontFamily: 'var(--font-body)',
                            color: '#75AD3E',
                          }}
                        >
                          Customer Details
                        </Typography>
                      </Box>
                      <Grid
                        container
                        spacing={2}
                        columnSpacing={7}
                        sx={{ mb: 4 }}
                      >
                        <Grid item xs={12} sm={6}>
                          <label
                            style={{
                              fontWeight: 'bold',
                              display: 'block',
                              marginBottom: '4px',
                            }}
                          >
                            First Name <span style={{ color: 'red' }}>*</span>
                          </label>
                          <input
                            type="text"
                            placeholder="First Name"
                            value={formData?.firstName}
                            onChange={(e) =>
                              setFormData({
                                ...formData,
                                firstName: e.target.value,
                              })
                            }
                            style={{
                              width: '100%',
                              padding: '10px',
                              // background: '#EDF4E5',
                              borderRadius: '8px',
                              border: '1px solid #ccc',
                            }}
                          />
                        </Grid>

                        <Grid item xs={12} sm={6}>
                          <label
                            style={{
                              fontWeight: 'bold',
                              display: 'block',
                              marginBottom: '4px',
                            }}
                          >
                            Last Name
                          </label>
                          <input
                            type="text"
                            placeholder="Last Name"
                            value={formData?.lastName}
                            onChange={(e) =>
                              setFormData({
                                ...formData,
                                lastName: e.target.value,
                              })
                            }
                            style={{
                              width: '100%',
                              padding: '10px',
                              borderRadius: '8px',
                              border: '1px solid #ccc',
                              // background: '#EDF4E5',
                            }}
                          />
                        </Grid>

                        <Grid item xs={12} sm={6}>
                          <label
                            style={{
                              fontWeight: 'bold',
                              display: 'block',
                              marginBottom: '4px',
                            }}
                          >
                            Email <span style={{ color: 'red' }}>*</span>
                          </label>
                          <input
                            type="email"
                            placeholder="Email"
                            value={formData?.email}
                            onChange={(e) =>
                              setFormData({
                                ...formData,
                                email: e.target.value,
                              })
                            }
                            style={{
                              width: '100%',
                              padding: '10px',
                              borderRadius: '8px',
                              border: '1px solid #ccc',
                              // background: '#EDF4E5',
                            }}
                          />
                        </Grid>

                        <Grid item xs={12} sm={6}>
                          <label
                            style={{
                              fontWeight: 'bold',
                              display: 'block',
                              marginBottom: '4px',
                            }}
                          >
                            Phone <span style={{ color: 'red' }}>*</span>
                          </label>
                          <PhoneInput
                            placeholder="Enter phone number"
                            defaultCountry="US"
                            countries={['US']} // only US
                            international={false}
                            value={formData.phone}
                            onChange={(value) =>
                              setFormData((prev) => ({
                                ...prev,
                                phone: value,
                              }))
                            }
                            style={{
                              width: '100%',
                              display: 'flex',
                              alignItems: 'center',
                              border: '1px solid #d1d5db',
                              borderRadius: '10px',
                              padding: '2px 14px',
                              fontSize: '16px',
                              backgroundColor: '#f9fafb',
                            }}
                            inputStyle={{
                              border: 'none',
                              outline: 'none',
                              flex: 1,
                              fontSize: '16px',
                              backgroundColor: 'transparent',
                              marginLeft: '8px',
                            }}
                            buttonStyle={{
                              display: 'none', // hides flag dropdown button
                            }}
                            countrySelectProps={{
                              style: {
                                display: 'none', // fully hides <select> (so no arrow)
                                appearance: 'none', // removes browser dropdown arrow if it tries to render
                                WebkitAppearance: 'none',
                                MozAppearance: 'none',
                              },
                            }}
                          />
                        </Grid>

                        <Grid item xs={12}>
                          <label
                            style={{
                              fontWeight: 'bold',
                              display: 'block',
                              marginBottom: '4px',
                            }}
                          >
                            Upload Image
                          </label>
                          <input
                            type="file"
                            accept="image/*"
                            onChange={(e) =>
                              setFormData({
                                ...formData,
                                image: e.target.files[0],
                              })
                            }
                            style={{ padding: '10px' }}
                          />
                        </Grid>
                      </Grid>
                    </Card>
                  </Card>
                </motion.div>
              </Grid>
            </Grid>

            <Box mt={5} mb={5} textAlign="center">
              <Grid
                container
                alignItems="center"
                justifyContent="center"
                spacing={2}
              >
                <Grid
                  item
                  xs={12}
                  sm={9}
                  sx={{ display: 'flex', justifyContent: 'center' }}
                >
                  <Box
                    sx={{
                      background: '#75AD3E',
                      color: 'white',
                      padding: '14px 20px',
                      borderRadius: '12px',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'space-between',
                      height: '100%',
                      width: '100%',
                    }}
                  >
                    <Typography
                      variant="h6"
                      fontWeight="500"
                      sx={{ color: 'white', fontFamily: 'var(--font-body)' }}
                    >
                      Grand total
                    </Typography>
                    <Typography
                      variant="h6"
                      fontWeight="500"
                      sx={{ color: 'white', fontFamily: 'var(--font-body)' }}
                    >
                      ${billing?.grand_total}
                    </Typography>
                  </Box>
                </Grid>

                <Grid
                  item
                  xs={12}
                  sm={3}
                  sx={{
                    display: 'flex',
                    justifyContent: 'center',
                  }}
                >
                  <Button
                    variant="contained"
                    size="large"
                    sx={{
                      fontSize: '20px',
                      fontWeight: '500',
                      borderRadius: '12px',
                      px: 3,
                      textTransform: 'none',
                      background: '#14331D',
                      color: 'white',
                      height: '100%',
                      minHeight: '56px',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      boxShadow: 3,
                      width: '100%',
                      maxWidth: { sm: 'none', md: '200px' },
                      '&:hover': {
                        backgroundColor: '#75AD3E',
                      },
                    }}
                    onClick={handlePlaceOrder}
                    disabled={orderLoading}
                  >
                    {orderLoading ? 'Placing Order...' : 'Place Order'}
                  </Button>
                </Grid>
              </Grid>
            </Box>
          </Container>
          {/* <CtaSection /> */}
          <Scrollbar />
          <Footer />
        </Box>
      </main>
    </>
  );
};

export default OrderPage;
